let dirPath = 'static/games/page006_game1';

let configGame = {
  removeInCorrects: true,
  correctBlock: true,
  //autoCheckAllCorrect: true,
  rulesGame: {
    itemsGarbage: [{ idGroup: 'source', itemsConfig: { block: false, shuffle: false } }],
    itemsConfig: {
      block: true,
    },
    items: [
      {
        idGroup: 'mapa',
        idItem: 'legend',
        itemsConfig: {
          shuffle: true,
        },
        items: [
          {
            idGroup: 'source',
            idItem: '10',
            correct: [{ idGroup: 'mapa', idItem: 'legend' }],
          },
          {
            idGroup: 'source',
            idItem: '11',
            correct: [{ idGroup: 'mapa', idItem: 'legend' }],
          },
          {
            idGroup: 'source',
            idItem: '12',
            correct: [{ idGroup: 'mapa', idItem: 'legend' }],
          },
        ],
      },
    ],
  },
  layout: {
    itemsConfig: {
      positions: {
        margin: { left: 5, bottom: 5 },
      },
      background: {
        color: 'transparent',
        text: { textAlign: 'center', bold: true },
      },
    },
    groups: [
      {
        idGroup: 'mapa',
        background: {
          color: 'transparent',
          //     color: 'pink',
          image: { src: dirPath + '/img/hook.png' },
        },
        positions: {
          type: 'absolute',
          pos: { x: 300, y: 50, height: 170, width: 170 },
        },
        items: [
          {
            id: 'legend',
            positions: {
              autoFit: true,
            },
            otherProperty: {
              hooks: {
                background: {
                  color: 'transparent',
                },
                positions: {
                  type: 'absolute',
                  pos: { height: 55, width: 213 },
                },
                items: [
                  {
                    id: 'hook0',
                    positions: { pos: { x: 0, y: 0, height: 170, width: 170 } },
                  },
                  {
                    id: 'hook1',
                    positions: { pos: { x: 0, y: 0, height: 170, width: 170 } },
                  },
                  {
                    id: 'hook2',
                    positions: { pos: { x: 0, y: 0, height: 170, width: 170 } },
                  },
                ],
              },
            },
          },
        ],
      },
      {
        idGroup: 'source',
        background: {
          color: 'transparent',
        },
        positions: {
          type: 'absolute',
          pos: { x: 200, y: 480 },
          autoFit: true,
        },
        itemsConfig: {
          positions: {
            pos: { height: 170, width: 170 },
            margin: { right: 10 },
            columns: 2,
          },
        },
        items: [
          {
            id: '05',
            background: {
              image: { src: dirPath + '/img/00.png' },
            },
          },
          {
            id: '06',
            background: {
              image: { src: dirPath + '/img/01.png' },
            },
          },
          {
            id: '07',
            background: {
              image: { src: dirPath + '/img/02.png' },
            },
          },
          {
            id: '04',
            background: {
              image: { src: dirPath + '/img/03.png' },
            },
          },
          {
            id: '03',
            background: {
              image: { src: dirPath + '/img/04.png' },
            },
          },
          {
            id: '10',
            background: {
              image: { src: dirPath + '/img/05.png' },
            },
          },
          {
            id: '11',
            background: {
              image: { src: dirPath + '/img/06.png' },
            },
          },
          {
            id: '12',
            background: {
              image: { src: dirPath + '/img/07.png' },
            },
          },
        ],
      },
    ],
  },
};

let dataConfig = {
  mixinEngine: 'dnd',
  // isDev: true,
  //   defaultConfig: dirPath + '/defaultConfig.json',
  //   realHeight: 790,
  //   realWidth: 1820,
  mainImage: {
    imagePath: dirPath + '/img/bgr.png',
    pos: {
      y: -7,
      x: 0,
    },
  },

  cssStyle: {
    overflow: 'hidden',
  },
  configGame: configGame,
};

export default dataConfig;
